import React from "react"
import { useFormikContext } from "formik"
import i18n from "@/i18n"
import { type ReservationFormValues } from "@/pages/public/venue"
import Footer from "../footer"
import { type GuestInformationStepProps, GuestFormFields } from "./shared"

const STYLES = {
  header: "border-b border-[#eef0f2] px-5 py-[15px]",
  title: "m-0 text-[16px] font-medium tracking-[-0.5px] text-[#201f1f]",
  holdDuration: "bg-[#f5f7f9] px-5 py-2 text-center text-[12px] leading-[18px] text-[#6b7280]",
  holdDurationStrong: "font-semibold text-[#414142]",
  formContainer: "space-y-4 px-6 py-5",
  footerContainer: "-mt-px bg-[#f5f7f9]",
} as const

const GuestInformationStepDesktop: React.FC<GuestInformationStepProps> = ({
  holdDurationSeconds,
  country,
  mobileSheet = false,
  onBack,
  onSubmit,
  isSubmitting,
}) => {
  const { values } = useFormikContext<ReservationFormValues>()
  const holdDurationMinutes = Math.max(1, Math.round((holdDurationSeconds ?? 5 * 60) / 60))
  const isValid = values.name && values.email && values.phone && values.termsAccepted
  const titleText = i18n.t("app.public.venue.modal.guest_info_title")

  return (
    <>
      <div className={STYLES.header} data-testid="public-reservation-modal-guest-header">
        <h2 className={STYLES.title}>{titleText}</h2>
      </div>

      <div className={STYLES.holdDuration} data-testid="public-reservation-modal-guest-hold-duration">
        <span>{`${i18n.t("app.public.venue.modal.hold_duration_prefix")} `}</span>
        <strong className={STYLES.holdDurationStrong}>
          {`${holdDurationMinutes} ${i18n.t("app.public.venue.modal.minutes")}`}
        </strong>
        <span>.</span>
      </div>

      <div className={STYLES.formContainer} data-testid="public-reservation-modal-guest-container">
        <GuestFormFields mobileSheet={mobileSheet} country={country} />
      </div>

      <Footer
        canGoNext={!!isValid}
        loading={isSubmitting}
        onBack={onBack}
        onNext={onSubmit}
        nextLabel={i18n.t("app.public.venue.modal.reserve_table")}
        containerClassName={STYLES.footerContainer}
        showTopBorder={false}
      />
    </>
  )
}

export default GuestInformationStepDesktop
